import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "controller_name",
  "use": "controller_name-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"controller_name\"><path d=\"m12.227 8.228-3.354 3.21a1.622 1.622 0 1 0 2.667 1.666l1.415-4.422a.443.443 0 0 0-.728-.454m2.482-3.166A6.996 6.996 0 0 0 5.063 7.29 7.001 7.001 0 0 0 10.993 18 7 7 0 0 0 14.71 5.062m.956 8.852a5.47 5.47 0 0 1-4.67 2.586 5.5 5.5 0 0 1-2.909-.836 5.507 5.507 0 0 1-1.75-7.579A5.48 5.48 0 0 1 11.008 5.5c1.026 0 2.031.29 2.907.836a5.51 5.51 0 0 1 1.75 7.579\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol